<template>
  <div class="main-content">
    <el-tag v-if="hasQueryTag" closable @close="clearQueryTag">{{
      queryTag
    }}</el-tag>
    <div>
      <ReposListPublic :repos="repos"></ReposListPublic>
    </div>
    <div class="paging">
      <el-pagination
        @current-change="handlePaginatorPageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="paging.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { OopsErrorELMessage, ReposMixin } from "@/mixins";
import ReposListPublic from "@/components/ReposListPublic";
export default {
  name: "Repos",
  mixins: [OopsErrorELMessage, ReposMixin],
  components: {
    ReposListPublic
  },
  created() {
    this.listRepos();
  }
};
</script>
